import { combineReducers } from '@reduxjs/toolkit';

export default (initialReducers) => {
  // Create an object which maps keys to reducers
  const reducers = { ...initialReducers };

  // Create the initial combinedReducer
  let combinedReducer = combineReducers(reducers);

  return {
    getReducerMap: () => reducers,

    getCombinedReducers: () => combinedReducer,

    has: (key) => !!reducers[key],

    // Adds a new reducer with the specified key
    add: (key, reducer) => {
      if (!key || reducers[key]) {
        return;
      }
      // Add the reducer to the reducer mapping
      reducers[key] = reducer;
      // Generate a new combined reducer
      combinedReducer = combineReducers(reducers);
    },

    // Removes a reducer with the specified key
    remove: (key) => {
      if (!key || !reducers[key]) {
        return;
      }
      // Remove it from the reducer mapping
      delete reducers[key];
      // Generate a new combined reducer
      combinedReducer = combineReducers(reducers);
    },

    removable: (key) => key && reducers[key],
  };
};
